// client/src/components/watchdog/ConfirmModal.jsx
// Dark-themed confirmation modal for destructive actions.

import React from "react";

const overlay = {
    position: "fixed",
    inset: 0,
    zIndex: 9999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(0,0,0,0.65)",
    backdropFilter: "blur(4px)",
};

const card = {
    background: "#1a1f2e",
    border: "1px solid rgba(139, 92, 246, 0.25)",
    borderRadius: "12px",
    padding: "28px 32px",
    minWidth: "380px",
    maxWidth: "480px",
    boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
};

const titleStyle = {
    fontSize: "16px",
    fontWeight: 700,
    color: "#e2e8f0",
    marginBottom: "12px",
};

const msgStyle = {
    fontSize: "13px",
    color: "#94a3b8",
    lineHeight: "1.6",
    marginBottom: "24px",
};

const btnRow = {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
};

const btnBase = {
    padding: "8px 20px",
    borderRadius: "8px",
    fontSize: "13px",
    fontWeight: 600,
    cursor: "pointer",
    border: "none",
    transition: "all 0.15s ease",
};

export default function ConfirmModal({
    open,
    title = "Confirm Action",
    message = "Are you sure?",
    confirmLabel = "Confirm",
    confirmColor = "#ef4444", // red by default for destructive
    onConfirm,
    onCancel,
}) {
    if (!open) return null;

    return (
        <div style={overlay} onClick={onCancel}>
            <div style={card} onClick={(e) => e.stopPropagation()}>
                <div style={titleStyle}>{title}</div>
                <div style={msgStyle}>{message}</div>
                <div style={btnRow}>
                    <button
                        style={{
                            ...btnBase,
                            background: "rgba(100, 116, 139, 0.2)",
                            color: "#94a3b8",
                        }}
                        onClick={onCancel}
                    >
                        Cancel
                    </button>
                    <button
                        style={{
                            ...btnBase,
                            background: confirmColor,
                            color: "#fff",
                        }}
                        onClick={onConfirm}
                    >
                        {confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    );
}
